module.exports = __webpack_public_path__ + "img/courier-purolator.df45a939.svg";